<script lang="ts">
    import Select from "../../widgets/Select.svelte"

    export let label: string
    export let init: { value: any }
    export let value: any = init?.value
    export let values
    export let valueFormat = (v) => v
    export let multiple = false

    export const reset = () => {
        value = ""
    }

    let options: any[]

    $: {
        console.log(values)
        options = [
            {
                value: "",
                label: valueFormat(""),
            },
        ]
        if (values) {
            values.forEach((v) => {
                options.push({
                    value: v,
                    label: valueFormat(v),
                })
            })
        }
    }
</script>

<div class="headline">{label}</div>
<Select options="{options}" bind:value="{value}" multiple="{multiple}" />

<style lang="less">
    .headline {
        font-size: 1.2rem;
        margin-bottom: 5px;

        @media (max-width: 1300px) {
            font-size: 1rem;
        }
    }
</style>
